import SVGIcon from "ui/icons/SVGIcon";
import type { IconStatusProps } from "./iconStatusTypes";

export default function IconSuccess({ outline = false, fill = "#47B279", ...props }: IconStatusProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <circle cx="8" cy="8" r="6" fill={outline ? "none" : fill} stroke={outline ? fill : "none"} />
      <path
        d="M11 6L7 10L5 8"
        stroke={outline ? fill : "white"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVGIcon>
  );
}
